import { render, staticRenderFns } from "./TranscriptDialog.vue?vue&type=template&id=d008c7ae&scoped=true&"
import script from "./TranscriptDialog.vue?vue&type=script&lang=js&"
export * from "./TranscriptDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d008c7ae",
  null
  
)

export default component.exports